<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">

        <h1>
          <p class="text-center font-weight-bold">Cadastrar Administrador de Unidade </p>
          <!-- {{recepcionista}} -->
        </h1>

        <v-form v-model="valid" ref="form" class="mx-4">
          <v-text-field label="Nome Completo" v-model="nome" :rules="nameCompleto" required></v-text-field>

          <v-text-field label="Username" v-model="username" :rules="nameRules" required></v-text-field>

          <v-text-field v-model="senha" :append-icon="show1 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show1 ? 'text' : 'password'" label="senha" counter @click:append="show1 = !show1"></v-text-field>

          <v-text-field v-model="senhaRepetida" autocomplete="new-password" :append-icon="show2 ? 'visibility' : 'visibility_off'" :rules="[this.senha == this.senhaRepetida || 'As Senha devem ser iguais']" :type="show2 ? 'text' : 'password'" label="Confirmar senha" counter @click:append="show2 = !show2"></v-text-field>
          <v-autocomplete label="Unidade" v-model="idUnidadeEscolhida" item-value="idUnidade" no-data-text="Nenhum unidade disponível" item-text="nomeUnidade" :items="listaUnidades" :rules="[(v) => !!v || 'Adicione uma unidade ']" required></v-autocomplete>

          <v-checkbox label="Voce Concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Voce deve concordar para cadastrar ']" required></v-checkbox>

          <v-alert :value="erroLogin" color="error" icon="warning" outlined>
            Username já existente !!
          </v-alert>

          <v-alert :value="sucessoLogin" color="success" icon="check_circle" outlined>
            Administrador Castrado com sucesso !!
          </v-alert>
        </v-form>
        <v-card-actions>
          <v-spacer />
           <v-btn rounded dark @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
          <v-btn text @click="" to='/listaAdministrador'>
            <v-icon left>keyboard_backspace</v-icon>
            voltar
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-layout>

</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../../services/administrador.service'

export default {
  name: 'CadastrarAdministrador',
  data () {
    return {
      show1: false,
      show2: false,
      valid: false,
      erroLogin: false,
      sucessoLogin: false,
      senha: '',
      senhaRepetida: '',
      respostaServidor: '',
      idUnidadeEscolhida: '',
      username: '',
      nome: '',
      listaUnidades: [],
      rules: {
        min: v => v.length >= 8 || 'Minimo 8 caracteres'
      },
      senhaRules: [
        (v) => v && v.length > 5 || 'Senha deve ter 6 ou mais caracteres'
      ],
      nameRules: [
        (v) => !!v || 'Nome obrigatório',
        (v) => v && v.length > 7 || 'Username deve ter mais de 7 caracteres '
      ],
      nameCompleto: [
        (v) => !!v || 'Nome completo obrigatório',
        (v) => v && v.length > 7 || 'deve ter mais de 7 caracteres '
      ],
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false

    }
  },
  components: {
    // HelloWorld
  },
  methods: {
    // isDisabled(){
    //   return this.nome !== '' && this.senha !== '' && this.idUnidadeEscolhida !== '';
    // },
    clear () {
      this.$refs.form.reset()
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.erroLogin = false
        this.sucessoLogin = false
        console.log('form valido')
        administradorService.administrador
          .cadastrarAdministrador(this.senha, this.username, this.idUnidadeEscolhida, this.nome)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)
            if (rsp.data == 'usernameExistente') {
              this.erroLogin = true
            }
            if (rsp.data == true) {
              this.sucessoLogin = true
              this.clear()
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    retornarUnidades () {
      console.log('em retornar unidades adm...')
      administradorService.administrador
        .retornarUnidades()
        .then(rsp => {
          console.log('rsp oi:')
          this.listaUnidades = rsp.data
          console.log(rsp.data.listaUnidades)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }

  },
  created () {
    console.log('created...')
  },
  mounted () {
    console.log('em mounted lista unid...')
    // console.log(this.user);
    this.clear()

    this.user = this.$store.getters.usuario
    this.retornarUnidades()
  }
}
</script>
